export default {
      id: "azs-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#azs",
      toString: function () {
        return this.url;
      }
    }